import { TypographyVariantsOptions } from "@mui/material/styles";

import { FontFamily } from "types/config";

// ==============================|| TOBY THEME - TYPOGRAPHY ||============================== //
// Mantis Plus Jakarta Sans text styles mapped onto MUI's 13 variants.

export default function Typography(
  fontFamily: FontFamily,
): TypographyVariantsOptions {
  return {
    htmlFontSize: 16,
    fontFamily,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
    h1: {
      fontWeight: 700,
      fontSize: "2.375rem", // 38px
      lineHeight: 46 / 38,
      letterSpacing: "-0.03em",
    },
    h2: {
      fontWeight: 700,
      fontSize: "1.875rem", // 30px
      lineHeight: 38 / 30,
      letterSpacing: "-0.01em",
    },
    h3: {
      fontWeight: 700,
      fontSize: "1.5rem", // 24px
      lineHeight: 32 / 24,
      letterSpacing: "-0.02em",
    },
    h4: {
      fontWeight: 700,
      fontSize: "1.25rem", // 20px
      lineHeight: 28 / 20,
      letterSpacing: 0,
    },
    h5: {
      fontWeight: 500,
      fontSize: "1rem", // 16px
      lineHeight: 24 / 16,
      letterSpacing: 0,
    },
    h6: {
      fontWeight: 500,
      fontSize: "0.875rem", // 14px
      lineHeight: 22 / 14,
      letterSpacing: "-0.02em",
    },
    subtitle1: {
      fontWeight: 400,
      fontSize: "1rem", // 16px
      lineHeight: 24 / 16,
      letterSpacing: 0,
    },
    subtitle2: {
      fontWeight: 500,
      fontSize: "0.875rem", // 14px
      lineHeight: 22 / 14,
      letterSpacing: "-0.02em",
    },
    body1: {
      fontWeight: 400,
      fontSize: "0.875rem", // 14px
      lineHeight: 22 / 14,
      letterSpacing: "-0.02em",
    },
    body2: {
      fontWeight: 400,
      fontSize: "0.75rem", // 12px
      lineHeight: 16 / 12,
      letterSpacing: 0,
    },
    button: {
      fontWeight: 500,
      fontSize: "0.875rem", // 14px
      lineHeight: 22 / 14,
      letterSpacing: "-0.02em",
      textTransform: "none",
    },
    caption: {
      fontWeight: 500,
      fontSize: "0.75rem", // 12px
      lineHeight: 20 / 12,
      letterSpacing: 0,
    },
    overline: {
      fontWeight: 500,
      fontSize: "0.75rem", // 12px
      lineHeight: 20 / 12,
      letterSpacing: "0.08em",
      textTransform: "uppercase",
    },
  };
}
